/**
 * Kalibre yazı yüzleri (DESIGN.md: Gabarito · Hanken Grotesk · Martian Mono) — yalnız bu dili
 * kullanan ekran açılınca bir kez yüklenir; panelin geri kalanı etkilenmez.
 */
// Kendi sunucumuzdan (public/fonts/kalibre, 2026-10-23): Google Fonts'a istek gitmez — çerez politikası
const FONT_URL = `${process.env.PUBLIC_URL || ''}/fonts/kalibre/kalibre.css`;

export default function kalibreFontYukle() {
  if (typeof document === 'undefined' || document.getElementById('kalibre-fontlar')) return;
  const l = document.createElement('link');
  l.id = 'kalibre-fontlar';
  l.rel = 'stylesheet';
  l.href = FONT_URL;
  document.head.appendChild(l);
}
